<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-simple-table class="table-inv">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">#</th>
                                <th class="text-center">
                                    Branch
                                </th>
                                <th class="text-center">
                                    Name
                                </th>
                                <th class="text-center">
                                    Volume Job
                                </th>
                                <th class="text-center">
                                    Km.
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in data_top" :key="index">
                                <td class="text-center">{{ index + 1 }}.</td>
                                <td>
                                    {{ row.branch_name }}
                                </td>
                                <td>
                                    {{ row.ce_name }}
                                </td>
                                <td class="text-center">
                                    <span
                                        :style="
                                            form_top_view.type == 'volume'
                                                ? ' font-weight: bold; color:#114f96'
                                                : ''
                                        "
                                    >
                                        {{ row.volume_job }}
                                    </span>
                                </td>
                                <td class="text-right">
                                    <span
                                        :style="
                                            form_top_view.type == 'distance'
                                                ? ' font-weight: bold; color:#114f96'
                                                : ''
                                        "
                                        >{{ row.sum_km }}</span
                                    >
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    props: ["data_top", "form_top_view"],
}
</script>
